var TextShape = /** @class */ (function () {
    function TextShape() {
        this.verts = [];
        this._length = 0;
        this.verts = [];
    }
    Object.defineProperty(TextShape.prototype, "length", {
        get: function () {
            return this._length;
        },
        set: function (val) {
            if (val > this._length) {
                return;
            }
            var verts = this.verts;
            if (val === 0) {
                this._length = 0;
                verts.length = 0;
                return;
            }
            var index = 0;
            var size = val;
            while (index < verts.length && size > 0) {
                size -= verts[index].length;
                index++;
            }
            if (size < 0) {
                // resize buffer
                verts[index - 1] = verts[index - 1].subarray(0, size + verts[index - 1].length);
            }
            verts.length = index;
            this._length = val;
        },
        enumerable: true,
        configurable: true
    });
    TextShape.prototype.addChunk = function (buffer) {
        this._length += buffer.length;
        this.verts.push(buffer);
    };
    Object.defineProperty(TextShape.prototype, "tall", {
        get: function () {
            return this.verts[this.verts.length - 1];
        },
        enumerable: true,
        configurable: true
    });
    return TextShape;
}());
export { TextShape };
